import { NS_CONFIGURATION, PROJECT, EDITOR, CATEGORY, CURRENT } from 'redux/constants';
import { action, createType, ASYNC, SYNC } from 'redux-create-type';


export const {
  INIT,
  SET_NAME,
  SET_COLOR,
  SET_ORDER,
  SET_IS_ACTIVE,
  SET_ITEMS,
  SET_ROLES,
  SET_ROLES_SECONDARY,
  SET_DEPENDENCIES,
  INVALIDATE_CHANGES,
  SET_REMOVED,
  RESET_CHANGES,
  SET_COMPLEXITY,
  SET_FORECAST_PREFIX,
  SET_LOG_SPENT_TIME,
  CHECK_VALIDATION,
} = createType(NS_CONFIGURATION, PROJECT, EDITOR, CATEGORY, CURRENT)({
    INIT: ASYNC,
    SET_NAME: SYNC,
    SET_COLOR: SYNC,
    SET_ORDER: SYNC,
    SET_COMPLEXITY: SYNC,
    SET_FORECAST_PREFIX: SYNC,
    SET_IS_ACTIVE: SYNC,
    INVALIDATE_CHANGES: SYNC,
    SET_ITEMS: SYNC,
    SET_ROLES: SYNC,
    SET_ROLES_SECONDARY: SYNC,
    SET_DEPENDENCIES: SYNC,
    SET_REMOVED: SYNC,
    SET_LOG_SPENT_TIME: SYNC,
    RESET_CHANGES: ASYNC,
    CHECK_VALIDATION: ASYNC,
  });


export const init = {
  begin: localId => action(INIT.BEGIN, { localId }),
  end: ({ selectedCategory }) => action(INIT.END, { selectedCategory }),
};
export const setName = name => action(SET_NAME, { name });
export const setColor = color => action(SET_COLOR, { color });
export const setOrder = order => action(SET_ORDER, { order });
export const setComplexity = complexity => action(SET_COMPLEXITY, { complexity });
export const setForecastPrefix = value => action(SET_FORECAST_PREFIX, { value });
export const setLogSpentTime = value => action(SET_LOG_SPENT_TIME, { value });
export const setRemoved = value => action(SET_REMOVED, { value });
export const setItems = ({ items }) => action(SET_ITEMS, { items });
export const setRoles = ({ roles }) => action(SET_ROLES, { roles });
export const setSecondaryRoles = ({ roles }) => action(SET_ROLES_SECONDARY, { roles });
export const setDependencies = ({ items }) => action(SET_DEPENDENCIES, { items });
export const invalidateChanges = ({ changes }) => action(INVALIDATE_CHANGES, { changes });
export const resetChanges = {
  begin: () => action(RESET_CHANGES.BEGIN),
  end: ({
    value,
    }) => action(RESET_CHANGES.END, {
      value,
    }),
};
export const checkValidation = {
  begin: () => action(CHECK_VALIDATION.BEGIN),
  end: ({ errors }) => action(CHECK_VALIDATION.END, { errors })
}


// WEBPACK FOOTER //
// ../redux/store/configuration/project/editor/category/currentCategory/actions.js